import { CLOSE_NAV_DROPDOWN, closeNavDropdown, OPEN_NAV_DROPDOWN, openNavDropdown } from './actions'

interface NavDropdownState {
  openedDropdown: string | null
}

export const initialState = (): NavDropdownState => {
  return {
    openedDropdown: null,
  }
}

type Action = ReturnType<typeof openNavDropdown> | ReturnType<typeof closeNavDropdown>

export default function root(
  state: NavDropdownState = initialState(),
  action: Action,
): NavDropdownState {
  switch (action.type) {
    case OPEN_NAV_DROPDOWN: {
      const payload = (action as ReturnType<typeof openNavDropdown>).payload
      return {
        ...state,
        openedDropdown: payload,
      }
    }

    case CLOSE_NAV_DROPDOWN:
      return {
        ...state,
        openedDropdown: null,
      }

    default:
      return state
  }
}
